"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useShouldSpeakIncomingActivity;

var _react = require("react");

var _WebChatReduxContext = require("../WebChatReduxContext");

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useShouldSpeakIncomingActivity() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      startSpeakingActivity = _useWebChatUIContext.startSpeakingActivity,
      stopSpeakingActivity = _useWebChatUIContext.stopSpeakingActivity;

  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var shouldSpeakIncomingActivity = _ref.shouldSpeakIncomingActivity;
    return shouldSpeakIncomingActivity;
  }), (0, _react.useCallback)(function (value) {
    value ? startSpeakingActivity() : stopSpeakingActivity();
  }, [startSpeakingActivity, stopSpeakingActivity])];
}